import React from "react";
import classNames from "classnames/bind";
import styles from "../../AddJobModal.module.scss";
import { JobStep } from "../../types/add-job.types";

const cx = classNames.bind(styles);

interface ContactTypeSelectorProps {
  jobStep: JobStep;
  onChange: (type: JobStep) => void;
}

const ContactTypeSelector: React.FC<ContactTypeSelectorProps> = ({
  jobStep,
  onChange,
}) => {
  return (
    <div className={cx("contact-type")}>
      <h4 className={cx("title")}>Contact Selection</h4>
      <div className={cx("actions")}>
        <button
          className={cx("button", {
            active: jobStep === "Existing",
          })}
          onClick={() => onChange("Existing")}
        >
          Existing Contact
        </button>
        <button
          className={cx("button", {
            active: jobStep === "New",
          })}
          onClick={() => onChange("New")}
        >
          New Contact
        </button>
      </div>
    </div>
  );
};

export default ContactTypeSelector;



